import { t } from "@/i18n-js/instance";
import type { ResourceSection } from "../shared/types";
import circleAcademyIcon from "./circle-academy.svg";

const localeRoot = "community_onboarding.new_checklist.resources";

export const createAcademyResource = (
  isCommunityOnPaidPlan: boolean,
  handleUpgrade: () => void,
): ResourceSection => ({
  icon: circleAcademyIcon,
  title: t(`${localeRoot}.sections.circle_academy.title`),
  description: t(`${localeRoot}.sections.circle_academy.description`),
  iconAlt: t(`${localeRoot}.sections.circle_academy.icon_alt`),
  ...(isCommunityOnPaidPlan
    ? {
        link: "https://circle-academy.circle.so/",
      }
    : {
        button: {
          label: t(`${localeRoot}.sections.circle_academy.button.label`),
          handleClick: handleUpgrade,
        },
      }),
});
